<template>
  <div class="user-card__show-information" v-b-modal.collapseuserinfo @click="openUserInformationModal()">
    {{$te('VMX.user_information_showuserinfo') ? $t('VMX.user_information_showuserinfo') : 'User Information'}}
    <font-awesome-icon :icon="['fas', 'info-circle']" />
  </div>
</template>

<script>

export default {
  methods: {
    openUserInformationModal() {
      this.$root.$emit('openUserInformationModal')
    },
  },
}
</script>
